import { SaveInternalBannersResult } from '../../../typings/banners';

export const SAVE_INTERNAL_BANNERS_SUCCESS = 'SAVE_INTERNAL_BANNERS_SUCCESS';
export type SAVE_INTERNAL_BANNERS_SUCCESS = typeof SAVE_INTERNAL_BANNERS_SUCCESS;
export interface SaveInternalBannersSuccess {
    type: SAVE_INTERNAL_BANNERS_SUCCESS;
    result: SaveInternalBannersResult;
}

export function saveInternalBannersSuccessAction(result: SaveInternalBannersResult): SaveInternalBannersSuccess {
    return {
        type: SAVE_INTERNAL_BANNERS_SUCCESS,
        result
    };
}
